module.exports = __webpack_public_path__ + "img/Back Bar & Drinks.7d436255.svg";